// extracted by mini-css-extract-plugin
module.exports = {"bannerProperties":"BannerProperties_bannerProperties__n4Xuh"};